import { SECURITY_LEVEL } from '@pperform/pp-constants/widgetConfigs';
import LoadingScreen from 'components/LoadingScreen';
import RetrySearchForm from 'components/RetrySearchForm';
import { TrackingDetailsHeader } from 'components/MerchantTrackingWidget/components/TrackingDetailsHeader';
import { BlankProgressIndicator } from 'components/MerchantTrackingWidget/components/BlankProgressIndicator';
import { usePTPConfigContext } from 'GlobalConfig.context';
import {
  Container,
  MainContent,
  SearchFormBox,
  ProgressIndicatorContainer,
} from './TrackingDetails.styles';

interface TrackingDetailsProps {
  isLoading: boolean;
  isNoShipment: boolean;
}
export const TrackingDetails = ({
  isLoading,
  isNoShipment,
}: TrackingDetailsProps): JSX.Element => {
  const {
    merchantCustom: { noInfoDisplayMessage2 },
    securityLevelBox: { securityLevel },
  } = usePTPConfigContext();

  const renderBody = () => {
    if (isLoading) {
      return <LoadingScreen />;
    }

    const isEncryptedOnly = securityLevel === SECURITY_LEVEL.ENCRYPTED_IDS_ONLY;
    if (isNoShipment && !isEncryptedOnly) {
      return (
        <SearchFormBox>
          <RetrySearchForm messageSearchForm={noInfoDisplayMessage2} />
        </SearchFormBox>
      );
    }

    return null;
  };

  return (
    <Container>
      <TrackingDetailsHeader />
      <ProgressIndicatorContainer>
        <BlankProgressIndicator />
      </ProgressIndicatorContainer>
      <MainContent>{renderBody()}</MainContent>
    </Container>
  );
};
